module.exports = __webpack_public_path__ + "img/planta_01.56bd6a00.jpg";